// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"394":"003faa33","498":"354d40aa","703":"6f08a8cb"}[chunkId] + ".chunk.js";
};